import { render, staticRenderFns } from "./SolicitudesStatus.graphic.vue?vue&type=template&id=26b4a9b9&scoped=true"
import script from "./SolicitudesStatus.graphic.vue?vue&type=script&lang=js"
export * from "./SolicitudesStatus.graphic.vue?vue&type=script&lang=js"
import style0 from "./SolicitudesStatus.graphic.vue?vue&type=style&index=0&id=26b4a9b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b4a9b9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardTitle})
